const GOOGLE_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbzLcs6dfCZvpvS0rc9z4sNJTddus6h_e-LIwiTy_-NstQQCMU_LGfBq9KI2NuyLfC8/exec'

export async function submitToGoogleSheets(
  contact: string,
  source: string,
): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // Required for Google Apps Script
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        contact,
        source,
      }),
    })

    // Note: With no-cors mode, we can't read the response
    // We assume success if no error is thrown
    return { success: true }
  } catch (error) {
    console.error('Error submitting to Google Sheets:', error)
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    }
  }
}
